import React, { Component } from 'react';
import { connect } from 'react-redux';
// import shared from '../../utils/shared.js';
import StoryAnnouncement from '../Theme/Chicago/StoryAnnouncement';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup'
import _ from 'lodash';
import { Switch, Route } from 'react-router-dom';

const NO_REDUX = "NO_REDUX";

class PreviewContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      module: {},
      secondaryModules: []
    }
  }

  componentDidMount() {
    this.prepareContent();
  }

  componentDidUpdate(prevProps, prevstate) {
    if (this.props !== prevProps) {
      this.prepareContent();
    }
  }

  prepareContent = () => {
    let mainModule = _.get(this.props, 'content.module', {});
    let secondaryModules = _.get(this.props, 'content.dm_active', []);

    this.setState({
      module: mainModule,
      secondaryModules: secondaryModules
    });
  }

  render() {
    const { location } = this.props;
    const key = this.props.location.pathname + this.props.location.search;
    return (
      <div>
        <CSSTransitionGroup
          component='div'
          className="fastfadedelay"
          style={{ minHeight: '100%' }}
          transitionName='example'
          transitionEnterTimeout={0}
          transitionLeaveTimeout={0}>
          <Switch key={key} location={location}>
            <Route path='/preview/Chicago/story/baby_announcement' render={props => <StoryAnnouncement mode={NO_REDUX} story={this.state.module} otherModules={this.state.secondaryModules} screen={this.props.screen} />} />
          </Switch>
        </CSSTransitionGroup >
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    ...state
  }
}

export default connect(mapStateToProps, null)(PreviewContainer);


// WEBPACK FOOTER //
// ./src/Components/Preview/PreviewContainer.jsx